module.exports = __webpack_public_path__ + "img/customerLogo1.61f83e5a.png";